import { Injectable } from '@angular/core';
import { TimelineEvent } from '../../../../shared/models/profile-timeline/timeline-event';
import { ApiEndpoints } from '../../../../shared/services/api-endpoints.service';
import { Observable } from 'rxjs';
import { TimelineEventMap } from '../../../../shared/models/profile-timeline/timeline-event-map';

@Injectable({
  providedIn: 'root',
})
export class ProfileTimelineService {
  constructor(private apiEndpoint: ApiEndpoints) {}

  /**
   *
   * @param agentId
   * @param leadId
   *
   * @return
   */
  getActivities(
    agentId: string,
    leadId: string,
    page: number,
    limit: number,
  ): Observable<{ count: number; content: TimelineEventMap[] }> {
    let pathParams = { agentId: agentId, leadId: leadId };
    let queryParams = { page: page, limit: limit };
    return this.apiEndpoint.get('getLeadEvents', queryParams, pathParams);
  }

  /**
   *
   * @param lead - the target lead
   * @param event - event to post
   */
  addActivity(event) {
    return this.apiEndpoint.post('postLeadEvents', event);
  }

  /**
   *
   * @param activityId
   * @param event
   */
  editActivity(activityId: string, event: TimelineEventMap) {
    return this.apiEndpoint.post('editLeadEvents', event, {
      activityId: activityId,
    });
  }

  /**
   *
   * @param activityId
   */
  deleteActivity(activityId: string) {
    return this.apiEndpoint.get(
      'deleteLeadEvents',
      {},
      { activityId: activityId },
    );
  }
}
